<template>
	<div class="downloadImg-page">
		<div class="goback" @click="$router.go(-1)">返回</div>
		<img :src="imgUrl" style="width:100%;height: 100vh;margin-bottom: -15px;position:absolute;overflow: hidden;">
		<div class="ewm-box">
			<!-- <img src="../images/WechatIMG59.png" class="wechat"> -->
			<QRCodeCanvas :msg="imgUrl"></QRCodeCanvas>
		</div>
	</div>
</template>
<script>
  // import utils from '../../assets/utils.js'
  import QRCodeCanvas from './qrCode.vue'
export default {
  name: 'downloadImg',
  data () {
    return {
      imgUrl:'',
      ewmImg:'',
      isShow:false
    }
  },
  components: {
	  QRCodeCanvas
	},
  mounted(){
    var imgUrl = this.$route.query.imgUrl;
    this.imgUrl = imgUrl;
  },

  methods:{
    
  }
}
</script>
<style>
	.downloadImg-page{
		position: relative;
	}
	.ewm-box{
		width:3.6rem;
		height: 5rem;
		position: relative;
	    /*top: 50%;*/
	    left: 56%;
	}

	.ewm-box img.wechat{
		width:7rem;
		height:9rem;
		position: absolute;
		top: 45%
	}
</style>


// WEBPACK FOOTER //
// src/components/downloadImg.vue